import { isEmpty, isNotEmpty, getPwdLevel } from './func';
import { getBankCardReg } from '@/utils/bankCardReg';
const { datas } = getBankCardReg();

/**
 * 检查输入字符长度
 * @param {number} length - 字符长度
 * @param {function(rest: any)} [exCallback] - 额外回调
 * @return {function(rule: Object, value: any, callback: function(cb: string | Error))}
 */
export function checkStringLength(length, exCallback) {
    return (rule, value, callback) => {
        if (isEmpty(value)) {
            return callback(new Error(`${rule._title || rule.label}不能为空`));
        }
        if (value.length > length) {
            if (exCallback) exCallback(value);
            return callback(new Error(`输入不能超过${length}个字`));
        }
        callback();
    };
}

/**
 * 验证手机号
 * @return {function(rule: Object, value: any, callback: function(cb: string | Error))}
 */
export function checkPhoneNumber() {
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error(`${rule._title}不能为空`));
        }
        const mobileReg = /^1[3456789]\d{9}$/;
        if (isNotEmpty(value) && !mobileReg.test(value)) {
            return callback(new Error('请输入正确的手机号'));
        }
        callback();
    };
}

/**
 * 验证传真号
 * @return {function(rule: Object, value: any, callback: function(cb: string | Error))}
 */
export function checkFax() {
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error(`${rule._title}不能为空`));
        }
        const mobileReg = /^(\+\d{1,2}-)?(0\d{2,3}-)?\d{7,8}(?:-\d{1,6})?$/;
        if (isNotEmpty(value) && !mobileReg.test(value)) {
            return callback(new Error('请输入正确的传真号'));
        }
        callback();
    };
}

/**
 * 验证身份证号码
 * @return {function(rule: Object, value: any, callback: function(cb: string | Error))}
 */
export function checkIdCard() {
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error(`${rule._title}不能为空`));
        }
        const reg =
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

        if (isNotEmpty(value) && !reg.test(value)) {
            return callback(new Error('请输入正确的身份证号码'));
        }
        callback();
    };
}
/**
 * 验证银行卡号
 * @return {function(rule: Object, value: any, callback: function(cb: string | Error))}
 */
export function checkBankCardNo() {
    const regList = datas.map((tmp) => tmp.patterns).flat(2);
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error(`${rule._title}不能为空`));
        }
        if (isNotEmpty(value)) {
            let pass = false;
            const result = value.replace(new RegExp(' ', 'g'), '');
            for (let i = 0; i < regList.length; ++i) {
                if (pass) break;
                const item = regList[i];
                let regStr = item.reg;
                regStr = regStr.replace(new RegExp('/', 'g'), '');
                regStr = regStr.replace(new RegExp('g', 'g'), '');
                regStr = regStr.replace(new RegExp('d{', 'g'), 'd{');
                const reg = new RegExp(regStr);
                pass = reg.test(result);
            }
            if (!pass) {
                return callback(new Error('请输入正确的银行卡号'));
            }
        }
        callback();
    };
}

// 密码强度验证
export function pwdValidator() {
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error('密码不能为空'));
        }
        const level = getPwdLevel(value);

        if (value.length < 8 || value.length > 16) {
            callback('密码位数为8~16位');
        } else if (level < 3 || /[^(_|~|@|#|\\$|\\^|\w)]/.test(value)) {
            callback(
                '需使用大写字母、小写字母、数字及特殊字符（_~@#$^）四种字符中至少3种的组合'
            );
        } else {
            callback();
        }
    };
}

export function checkAllPhoneNumber() {
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error(`${rule._title}不能为空`));
        }
        const mobileReg = /^1[3456789]\d{9}$/;
        const valList = value.split(',');
        const errorIndex = [];
        valList.forEach((phone, index) => {
            if (isNotEmpty(phone) && !mobileReg.test(phone)) {
                errorIndex.push(index + 1);
            }
        });
        if (errorIndex.length > 0) {
            return callback(`第${errorIndex.join(',')}个手机号输入错误`);
        }
        callback();
    };
}

export function checkAllIdCard() {
    return (rule, value, callback) => {
        if (isEmpty(value) && rule.required) {
            return callback(new Error(`${rule._title}不能为空`));
        }
        const idCardReg =
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        const valList = value.split(',');
        const errorIndex = [];
        valList.forEach((idCard, index) => {
            if (isNotEmpty(idCard) && !idCardReg.test(idCard)) {
                errorIndex.push(index + 1);
            }
        });
        if (errorIndex.length > 0) {
            return callback(`第${errorIndex.join(',')}个身份证输入错误`);
        }
        callback();
    };
}
